import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { CAMPAIGN_ID_PARAM } from "@/constants";
import { resolveHrefWithCampaign } from "@/lib/campaign";
import type { PushParams } from "@/types/global/route";

import { hasAppHistory } from "@luce/core/adapters/navigation";

import { backOrHome } from "./back";

export const useRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get(CAMPAIGN_ID_PARAM) ?? undefined;

  return {
    push: (p: PushParams | string) => {
      return navigate(resolveHrefWithCampaign(p, campaignId));
    },
    canGoBack: hasAppHistory,
    pull: () =>
      backOrHome({
        canGoBack: hasAppHistory,
        back: () => void navigate(-1),
        replace: (path) => void navigate(path, { replace: true }),
      }),
    replace: (p: PushParams | string) => {
      return navigate(resolveHrefWithCampaign(p, campaignId), {
        replace: true,
      });
    },
    dismissTo: (path = "/") => {
      navigate(path, { replace: true });
    },
  };
};

export const Redirect = ({ path, replace = true }: { path: string; replace?: boolean }) => {
  return <Navigate to={path} replace={replace} />;
};
